<template>
  <b-container fluid >
    <b-row>
      <b-col md="12" class="allCardList p-0">
        <iq-card>
          <template v-slot:headerTitle>
            <div style="display:flex;justify-content: space-between;align-items: center;">
              <h4 class="card-title">
                <i class="fa-solid fa-building building_icon"></i>
                Edit Your Organisation
              </h4>
              <button type="button" @click="goToOrgSaasLoginPreview" class="btn btn-primary border-0 rounded px-3 py-2">
                View Login Page
              </button>
            </div>
          </template>
        </iq-card>
          <CropImage :prop-crop-image-dialog-open="propCropImageDialogOpen" :propCropModalSize="propCropDialogSize" :prop-stencil-size="propStencilSize" :propSrc="fileSrc" @emitCroppedImg="getCroppedImg" @emitCroppedImgFile="emitCroppedImgFile" />
      </b-col>
      <b-col class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
        <div class="tab-content">
            <div class="iq-card rounded p-3 bg-white row">
              <h4 class="mb-4 primary-color col-12">Organisation Details</h4>

              <!-- Orgnanisation Name -->
              <div class="col-12">
                <h5>{{ cvOrgNameLabel }}</h5>
                <ValidationObserver ref="orgForm" >
                  <b-form>
                    <div class="col-md-12 mb-3 mt-2 p-0">
                      <ValidationProvider name="Organisation Name" rules="required|max:100" v-slot="{ errors }">
                        <input v-model="vmOrganisationFormData.org_name" type="text" class="form-control" :placeholder="cvOrgNameLabel" required />
                        <span v-if="vmOrganisationFormData.org_name && errors[0]" class="text-danger"> Name may not be more than 100 characters.</span>
                      </ValidationProvider>
                    </div>
                  </b-form>
                </ValidationObserver>
              </div><!-- Orgnanisation Name -->

              <!-- Primary Email Id -->
              <div class="col-12 mb-3">
                <h5>{{ cvRegisteredEmailLabel }}&nbsp;&nbsp;<a :href="`mailto:${supportEmail}`"><i :title="`Contact ${supportEmail} to modify ${cvRegisteredEmailLabel}`" class="primary-color pointer fa fa-info-circle" aria-hidden="true"></i></a></h5>
                <ValidationObserver ref="orgForm" >
                  <b-form>
                    <div class="col-md-12 mb-1 mt-2 p-0">
                      <ValidationProvider name="Primary Email Id" rules="required" v-slot="{ errors }">
                        <input v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" v-model="vmOrganisationFormData.org_admin_email" type="text" class="form-control" :placeholder="cvRegisteredEmailLabel" required>
                        <input v-else v-model="vmOrganisationFormData.org_admin_email" type="text" class="form-control" :placeholder="cvRegisteredEmailLabel" required readonly/>
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-form>
                </ValidationObserver>
              </div><!-- Registered Email Id -->

              <!-- Mobile Country Code -->
              <b-col class="col-12 col-md-6">
                <div>
                <h5>{{ cvMobileCountryLabel }}</h5>
                  <ValidationProvider name="Mobile Country Code" rules="required|min:2" v-slot="{ errors }">
                    <div class="col-md-12 mb-1 mt-2 p-0">
                      <select v-model="vmOrganisationFormData.org_mobile_country_code" class="form-control w-100" id="validation_country">
                        <template class="w-100">
                          <option class="w-100" v-for="(country, index) of cvCountryOptions" :key="index+'1'" :value="`+${country.country_phone_code}`">
                            {{country.country_name}} (+ {{country.country_phone_code}})
                          </option>
                        </template>
                      </select>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </div>
                  </ValidationProvider>
                </div>
              </b-col><!-- Mobile Country Code -->

              <!-- Mobile -->
              <div class="col-12 col-md-6">
                <h5>{{ cvMobileLabel }}</h5>
                <ValidationObserver ref="orgForm" >
                  <b-form>
                    <div class="col-md-12 mb-3 mt-2 p-0">
                      <ValidationProvider name="Mobile Number" rules="required" v-slot="{ errors }">
                        <input v-model="vmOrganisationFormData.org_mobile" type="text" class="form-control" :placeholder="cvMobileLabel" required />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-form>
                </ValidationObserver>
              </div><!-- Mobile -->

              <!-- Office Address -->
              <div class="col-12">
                <h5>{{ cvOfficeAddressLabel }}</h5>
                <ValidationObserver ref="orgForm" >
                  <b-form>
                    <div class="col-md-12 mb-3 mt-2 p-0">
                      <ValidationProvider name="Office Address" rules="required" v-slot="{ errors }">
                        <input v-model="vmOrganisationFormData.bill_address" type="text" class="form-control" :placeholder="cvOfficeAddressLabel" required />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-form>
                </ValidationObserver>
              </div><!-- Office Address -->

              <div class="form-row col-12">
                <!-- City -->
                <div class="col-6">
                  <h5>{{ cvCityLabel }}</h5>
                  <ValidationObserver ref="orgForm" >
                    <b-form>
                      <div class="col-md-12 mb-3 mt-2 p-0">
                        <ValidationProvider name="Office Address" rules="required" v-slot="{ errors }">
                          <input v-model="vmOrganisationFormData.bill_city" type="text" class="form-control" :placeholder="cvCityLabel" required />
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </b-form>
                  </ValidationObserver>
                </div><!-- City -->

                <!-- Zipcode -->
                <div class="col-6">
                  <h5>{{ cvZipCodeLabel }}</h5>
                  <ValidationObserver ref="orgForm" >
                    <b-form>
                      <div class="col-md-12 mb-3 mt-2 p-0">
                        <ValidationProvider name="Office Address" rules="required" v-slot="{ errors }">
                          <input v-model="vmOrganisationFormData.bill_zip_code" type="text" class="form-control" :placeholder="cvZipCodeLabel" required />
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </b-form>
                  </ValidationObserver>
                </div><!-- Zipcode -->
              </div>

              <div class="form-row col-12">
                <!-- State Dropdown -->
                <div class="col-6" v-if="isStateDropdown">
                  <h5>{{ cvStateLabel }}</h5>
                  <ValidationObserver ref="orgForm" >
                    <b-form>
                      <div class="col-md-12 mb-3 mt-2 p-0">
                        <select name="bill_state" id="validationbill_state" class="form-control" v-model="vmOrganisationFormData.bill_state_code" required>
                          <option :value="GSTStateCode[vmOrganisationFormData.bill_state_code]" selected>{{GSTStateCode[vmOrganisationFormData.bill_state_code]}}</option>
                          <option :value="index" v-for="(key, index) in GSTStateCode" :key="index">{{key}}</option>
                        </select>
                      </div>
                    </b-form>
                  </ValidationObserver>
                </div><!-- State Dropdown -->

                <!-- State Input -->
                <div class="col-6" v-else>
                  <h5>{{ cvStateLabel }}</h5>
                  <ValidationObserver ref="orgForm" >
                    <b-form>
                      <div class="col-md-12 mb-3 mt-2 p-0">
                        <ValidationProvider name="Office State" rules="required" v-slot="{ errors }">
                          <input v-model="vmOrganisationFormData.bill_state" type="text" class="form-control" :placeholder="cvStateLabel" required />
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </b-form>
                  </ValidationObserver>
                </div><!-- State Input -->

                <!-- Country Dropdown -->
                <div class="col-4">
                  <h5>{{cvCountryLabel}}</h5>
                  <div class="col-md-12 mb-3 mt-2 p-0">
                    <ValidationProvider name="Country" rules="required" v-slot="{ errors }">
                      <select v-model="vmOrganisationFormData.bill_country" class="form-control" @change="setStateFormField">
                        <template>
                          <option v-for="(country, index) of cvCountryOptions" :key="index+'1'" :value="country">
                            {{country.country_name}}
                          </option>
                        </template>
                      </select>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div><!-- Country Dropdown -->
              </div>

              <div class="col-12">
                <button type="button" @click="saveSaasOrgDetails" class="d-flex btn-primary border-0 px-3 py-2 rounded mt-3 mb-2">
                  Save
                </button>
              </div>

              <!-- Tax Documents -->
              <div class="col-12 p-0">
                <hr/>
                <OrgSaasTaxDocuments :propOpenedInModal="false" :propModuleObjId="cvOrgId" />
                <hr/>
              </div><!-- Tax Documents -->

              <!-- Site Domain Name -->
              <div class="col-12" v-if="hasWhiteLabelingEnabledInSubsPlan && vmOrganisationFormData.org_domain">
                <h5>
                  Your Website/Login Page Domain&nbsp;&nbsp;<a :href="`mailto:${supportEmail}`"><i :title="cvSiteDomainNameTooltip" class="primary-color pointer fa fa-info-circle" aria-hidden="true"></i></a><br>
                  <span class="primary-color">{{vmOrganisationFormData.org_domain}}</span>
                </h5>
              </div>
              <div class="col-12" v-else>
                <h5>{{ cvSiteDomainNameLabelDesc }}&nbsp;&nbsp;<a :href="`mailto:${supportEmail}`"><i :title="cvSiteDomainNameTooltip" class="primary-color pointer fa fa-info-circle" aria-hidden="true"></i></a></h5>
                <ValidationObserver ref="orgForm" v-if="hasWhiteLabelingEnabledInSubsPlan">
                  <b-form>
                    <div class="col-md-12 mb-3 mt-3 p-0">
                      <ValidationProvider name="Site Domain Name" rules="required" v-slot="{ errors }">
                        <input v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" v-model="vmOrganisationFormData.org_domain" type="text" class="form-control" :placeholder="cvSiteDomainNameLabel" required />
                        <input v-else v-model="vmOrganisationFormData.org_domain" type="text" class="form-control" :placeholder="cvSiteDomainNameLabel" required :readonly="readonlyFlag"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                        <span><small><span class="primary-color">*</span>Domain once added cannot be updated. Kindly contact <a :href="`mailto:${supportEmail}`">{{supportEmail}}</a> for updating the domain for your organisation</small></span>
                        <span v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'"><small><span class="primary-color">*</span>Don't forget to add the domain to Fontawesome.&nbsp;<span class="pointer primary-color"><a href='https://fontawesome.com/kits/ce5a76fdea/settings' target="_blank">Click Here to Add</a></span></small></span>
                      </ValidationProvider>
                    </div>
                  </b-form>

                  <button type="button" @click="saveSaasOrgDetails" class="d-flex btn-primary border-0 px-3 py-2 rounded mt-3 mb-2">
                    Save
                  </button>
                </ValidationObserver>
                <div v-else>
                  <span>Your current subscription plan does not allow you to use your own website domain, click on upgrade to activate this</span>
                  <button type="button" @click="goToSubsPlanList" class="d-flex btn-primary border-0 px-3 py-2 rounded mt-3 mb-2">
                    Upgrade
                  </button>
                </div>
              </div><!-- Site Domain Name -->

              <div class="mt-5" v-if="vmOrganisationFormData.org_domain && hasWhiteLabelingEnabledInSubsPlan">
                <h5>
                  Domain Validation
                </h5>
                <span v-if="vmOrganisationFormData.org_domain_is_validated == 'NOT_VALIDATED'">
                  <span class="primary-color">*</span>&nbsp;
                  Save your organisation and then click the validate button. Your domain shall be activated only after successful validation.
                  <button @click="goToOrgDomainValidate" type="button" class="d-flex btn-primary border-0 px-3 py-2 rounded mt-3">
                    Validate Your Domain
                  </button>
                </span>
                <span v-else-if="vmOrganisationFormData.org_domain_is_validated == 'HTTP_VALIDATION_COMPLETE'">
                  Domain Validation Completed. Generate Domain Security Certificate Pending
                  <button @click="goToOrgDomainValidate" type="button" class="d-flex btn-primary border-0 px-3 py-2 rounded mt-3">
                    Secure Domain Now
                  </button>
                </span>
                <span v-else-if="vmOrganisationFormData.org_domain_is_validated == 'SSL_CERTIFICATE_GENERATED'">
                  Security Certificated Generated. Domain Certificate Verification Pending
                  <button @click="goToOrgDomainValidate" type="button" class="d-flex btn-primary border-0 px-3 py-2 rounded mt-3">
                    Verify Domain Certifcate
                  </button>
                </span>
                <span v-if="userData.user_role == 'USERROLE11111'">
                  <span>Domain Secured and Ready to Use. Click to Regenrated the Cert if required</span><br>
                  <i title="Regenerate SSL Certificate" class="mt-2 pointer fa-solid font-size-24 fa-arrows-rotate primary-color" @click="goToOrgSaasDomainValidate"></i>
                </span>
              </div>
            </div>
        </div>
      </b-col>

      <b-col class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
        <div class="tab-content">
          <div class="iq-card rounded p-3">
            <h4 class="mb-4 primary-color">
              Organisation Branding
            </h4>
            <!-- Profile Picture -->
            <div>
              <h5>
                Profile Pic
              </h5>
              <hr>
              <b-form>
                <div class="form-group row align-items-center">
                  <div class="col-md-12">
                    <div class="profile-img-edit border border-dark" style="height: 150px; width: 150px; border-radius: 50%; ">
                      <img v-if="vmProfilePic" :src="vmProfilePic" alt="profile-pic " style="height: 100%; width: 100%; object-fit: contain; overflow: hidden; border-radius: 50%; " />
                      <i v-else class="fas fa-orgersity d-flex justify-content-center align-items-center rounded-circle " style="font-size: 5rem; height:100%; "></i>
                      <label class="p-image">
                        <i class="ri-pencil-line upload-button" style="cursor: pointer" ></i>
                        <input class="file-upload" type="file" accept="image/png,image/jpeg,image/jpg" id="fileInput1" style="display: block; position: absolute; opacity: 0; left: 0; top: 0;" @change="openImageDialog($event, 'Profile Pic')" />
                      </label>
                    </div>
                  </div>
                  <span class="text-danger" ref="proPicError"></span>
                  </div>
                  <button type="button" class=" p-2 mr-3 mb-2 rounded btn btn-primary border-0 "  :disabled="cvProfilePicError || cvProfilePicLoading" @click="imageEdit('Profile Pic')">
                    <b-spinner small class="ml-4 mr-4" v-if="cvProfilePicLoading" label="Spinning">
                    </b-spinner>
                    <span v-else>Save Profile Pic</span>
                  </button>
                  <button v-if="vmProfilePic" type="button" class="p-2 mb-2 rounded btn btn-primary border-0 " :disabled="cvProfilePicError || cvProfilePicLoading"  @click="imageRemove('profile_pic')">
                    <b-spinner small class="ml-4 mr-4" v-if="cvDelProfilePicLoading" label="Spinning">
                    </b-spinner>
                    <span v-else>Remove Profile Pic</span>
                  </button>
              </b-form>
            </div><!-- Profile Picture -->

            <!-- Cover Picture -->
            <div class="mt-4">
              <h5>
                Cover Pic
              </h5>
              <hr>
              <b-form>
                <div class="form-group row align-items-center">
                  <div class="col-md-12">
                    <div class="profile-img-edit border" style="height: 250px; width: 100%;">
                      <img v-if="vmCoverPic" :src="vmCoverPic" alt="profile-pic " style="height: 100%; width: 100%; object-fit: contain; overflow: hidden;" />
                      <i v-else class="fas fa-orgersity d-flex justify-content-center align-items-center" style="font-size: 5rem; height:100%; color: #c1c1c1;"></i>
                      <div class="p-image">
                        <i class="ri-pencil-line upload-button"></i>
                        <input class="file-upload" type="file" accept="image/png,image/jpeg,image/jpg" id="fileInput1" style="display: block; position: absolute; opacity: 0; left: 0; top: 0;" @change="openImageDialog($event, 'Cover Pic')" />
                      </div>
                      </div>
                    </div>
                    <span class="text-danger" ref="coverPicError"></span>
                  </div>
                  <button type="button" class="p-2 mr-3 rounded btn btn-primary border-0 " @click="imageEdit('Cover Pic')" >
                    <b-spinner small class="ml-4 mr-4" v-if="cvCoverPicLoading" label="Spinning">
                    </b-spinner>
                    <span v-else> Save Cover Pic</span>
                  </button>
                  <button v-if="vmCoverPic" type="button" class="p-2 rounded btn btn-primary border-0 " :disabled="cvProfilePicError || cvProfilePicLoading"  @click="imageRemove('cover_pic')">
                    <b-spinner small class="ml-4 mr-4" v-if="cvDelProfilePicLoading" label="Spinning">
                    </b-spinner>
                    <span v-else>Remove Cover Pic</span>
                  </button>
                </b-form>
            </div><!-- Cover Picture -->

            <!-- About Us Description -->
            <div class="mt-4">
              <h5>
                About Us Description
              </h5>
              <hr>
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <vue-editor v-model="vmOrganisationFormData.org_desc">
                  </vue-editor>
                  <button @click="saveSaasOrgDetails" type="button" class="d-flex btn-primary border-0 px-3 py-2 rounded mt-3" >
                    Save
                  </button>
                </div>
              </div>
            </div><!-- About Us Description -->
          </div>
        </div>
      </b-col>

      <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
        <div v-html="toastMsg">
        </div>
      </b-toast>
    </b-row>
  </b-container>
</template>
<style scoped >
  .iq-card-stretch{
    border-radius: 20px;
  }
  .followButton{
    min-height: unset;
    max-height: 50px;
  }
  .iq-card{
    background: transparent !important;
  }
</style>
<script>
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission"
import { VueEditor } from "vue2-editor"
import GSTStateCode from "../../../FackApi/json/GSTStateCode.json"
import CropImage from "../../../components/cropImage.vue"
import ApiResponse from "../../../Utils/apiResponse"
import { Images } from "../../../FackApi/api/image"
import { OrgSaas } from "../../../FackApi/api/orgSaas.js"
import { Countries } from "../../../FackApi/api/country.js"
import { User } from "../../../FackApi/api/user"
import pdfLogo from "../../../assets_gide/img/logo/pdfLogo.png"
import OrgSaasTaxDocuments from "./OrgSaasTaxDocuments.vue"
import { Organisations } from "../../../FackApi/api/organisation.js"

export default {
  name: "OrgSaasOrganisationEdit",
  data () {
    return {
      cvOrgNameLabel: "Official Name",
      cvOfficeAddressLabel: "Office Address",
      cvRegisteredEmailLabel: "Primary Email",
      cvSiteDomainNameLabelDesc: "Do you want to use own website domain ?",
      cvSiteDomainNameTooltip: "Setting your own domain on other's website is called white labeling. White labeling your domain means branding a product, service, or platform under your own name or company, even though it's built and maintained by another provider. In this process, the provider allows you to customize the appearance, branding, and sometimes functionality, so it looks like it's coming directly from your company.",
      cvSiteDomainNameLabel: "Eg: console.mydomain.com",
      cvMobileLabel: "Mobile",
      vmOrganisationProPicImage: null,
      cvCityLabel: "City",
      cvPancardNumberLabel: "PAN Card",
      cvZipCodeLabel: "Zipcode",
      cvDelProfilePicLoading: false,
      vmOrganisationCoverPicImage: null,
      propStencilSize: null,
      fileSrc: "",
      propCropImageDialogOpen: false,
      updateImageType: null,
      propCropDialogSize: "md",
      cvStateLabel: "State",
      cvCountryLabel: "Country",
      cvMobileCountryLabel: "Mobile Country Code",
      GSTStateCode: GSTStateCode,
      vmCoverPic: "",
      cvCoverPicLoading: false,
      vmProfilePic: "",
      cvProfilePicError: false,
      cvProfilePicLoading: false,
      vmOrganisationFormData: {},
      apiName: "orgsaas_organisation_view",
      showToast: false,
      cvOrgId: null,
      cvOrgType: null,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Organisation Edit",
      oldDomain: null,
      supportEmail: process.env.VUE_APP_SUPPORT_EMAIL,
      cvCountryOptions: [],
      isStateDropdown: false,
      readonlyFlag: false,
      pdfLogo: pdfLogo,
      allowedExtensions: "application/pdf",
      cvImageSizeErrorMsg: "PDF size must be less than 300 kb.",
      hasWhiteLabelingEnabledInSubsPlan: false
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  components: {
    VueEditor,
    CropImage,
    OrgSaasTaxDocuments
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }

    // The admin needs to access this page in order to create or edit organisations
    if (this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118") {
      return
    }

    this.orgType = this.$route.params.org_type
    this.cvOrgId = this.$route.params.org_id

    if (!(this.userData?.modules?.organisations &&
      this.userData?.modules?.organisations && this.userData.modules.organisations[this.cvOrgId] &&
      this.userData.modules.organisations[this.cvOrgId].org_id == this.cvOrgId)
    ) {
      // Not an owner of this organisation. Unauth Access. So Send back to home
      this.$router.push("/home")
    }
  },
  async mounted () {
    if (this.$route.params.org_id) {
      this.cvOrgId = this.$route.params.org_id
    }
    if (this.$route.params.org_type) {
      this.cvOrgType = this.$route.params.org_type
    }
    this.checkIsWhiteLabelingAvailableInSubsPlan()
    this.loadRequiredData()

    /* If the 'user_first_time_login' flag is , the user has successflly landed the edit page
    set the flag to 0 in the database */
    if ((this.userData.user_first_time_login == 1 || this.userData.user_first_time_login == "1") && this.userData.user_role == "USERROLE11116") {
      await User.userEdit(this, { user_id: this.userData.user_id, gide_user_id: this.userData.user_id, user_first_time_login: 0 })
    }
  },
  methods: {
    /**
     * checkIsWhiteLabelingAvailableInSubsPlan
     */
    async checkIsWhiteLabelingAvailableInSubsPlan () {
      try {
        const isWhileLabelResp = await OrgSaas.orgSaasSubsPlanCheck(this, { org_id: this.cvOrgId })
        if (isWhileLabelResp.resp_status) {
          this.hasWhiteLabelingEnabledInSubsPlan = isWhileLabelResp.resp_data.data.is_whitelabling_allowed
        }
      }
      catch (err) {
        console.error("Exception in checkIsWhiteLabelingAvailableInSubsPlan() and err: ", err.message)
      }
    },
    /**
     * saveSaasOrgDetails
     */
    async saveSaasOrgDetails () {
      try {
        let billCountryCopy = null
        if (this.isStateDropdown) {
          this.vmOrganisationFormData.bill_state = this.GSTStateCode[this.vmOrganisationFormData.bill_state_code]
        }
        else {
          this.vmOrganisationFormData.bill_state_code = null
        }
        if (this.oldDomain != this.vmOrganisationFormData.org_domain) {
          this.vmOrganisationFormData.org_domain_is_validated = "NOT_VALIDATED"
        }

        if (this.vmOrganisationFormData.bill_country) {
          billCountryCopy = this.vmOrganisationFormData.bill_country
          this.vmOrganisationFormData.bill_country = this.vmOrganisationFormData.bill_country["country_name"]
        }

        // always convert the org_domain to lower case
        if (this.vmOrganisationFormData.org_domain) {
          this.vmOrganisationFormData.org_domain = this.vmOrganisationFormData.org_domain.toLowerCase()
        }

        let saveOrgSaasResp = await OrgSaas.orgSaasOrganisationEdit(this, this.vmOrganisationFormData)
        ApiResponse.responseMessageDisplay(this, saveOrgSaasResp)
        this.vmOrganisationFormData.bill_country = billCountryCopy
      }
      catch (err) {
        console.error("Exception in saveSaasOrgDetails() and err: ", err)
      }
    },
    /**
     * countryDistinctList
     */
    async countryDistinctList () {
      try {
        let matchWithQuery = "distinct country"
        let countryDistinctListResp = await Countries.countryList(this, matchWithQuery)
        if (countryDistinctListResp && !countryDistinctListResp.resp_status) {
          return false
        }
        this.cvCountryOptions = countryDistinctListResp.resp_data.data
      }
      catch (err) {
        console.error("Exception occurred at countryDistinctList() and Exception:", err.message)
      }
    },
    /**
     * goToOrgDomainValidate
     */
    goToOrgDomainValidate () {
      window.open(`/org_domain_validate/${this.cvOrgType}/${this.cvOrgId}`, "_blank")
    },
    /**
     * loadRequiredData
     */
    async loadRequiredData () {
      await this.countryDistinctList()
      socialvue.index()
      this.orgSaasView()
    },
    /**
     * orgSaasView
     */
    async orgSaasView () {
      try {
        let orgSaasView = await OrgSaas.orgSaasOrganisationView(this, this.cvOrgId)
        if (!orgSaasView.resp_status) {
          this.toastVariant = "danger"
          this.toastMsg = orgSaasView.resp_msg
          this.showToast = true
          return
        }
        this.vmOrganisationFormData = orgSaasView.resp_data.data.org_data
        this.vmOrganisationFormData.org_pancard_attach = JSON.parse(this.vmOrganisationFormData.org_pancard_attach)

        this.oldDomain = orgSaasView.resp_data.data.org_data.org_domain

        this.vmProfilePic = orgSaasView.resp_data.data.org_data.org_profile_img
        this.vmCoverPic = orgSaasView.resp_data.data.org_data.org_cover_img

        if (orgSaasView.resp_data.data.org_admin_bill_details) {
          this.vmOrganisationFormData.bill_address = orgSaasView.resp_data.data.org_admin_bill_details.bill_address
          this.vmOrganisationFormData.bill_city = orgSaasView.resp_data.data.org_admin_bill_details.bill_city
          this.vmOrganisationFormData.bill_zip_code = orgSaasView.resp_data.data.org_admin_bill_details.bill_zip_code
          this.vmOrganisationFormData.bill_state = orgSaasView.resp_data.data.org_admin_bill_details.bill_state
          this.vmOrganisationFormData.bill_state_code = orgSaasView.resp_data.data.org_admin_bill_details.bill_state_code
          this.vmOrganisationFormData.bill_country = orgSaasView.resp_data.data.org_admin_bill_details.bill_country
        }

        if (this.vmOrganisationFormData.bill_country) {
          const findCountryIndex = this.cvCountryOptions.findIndex(country => country.country_name === this.vmOrganisationFormData.bill_country)
          if (findCountryIndex >= 0) {
            this.vmOrganisationFormData.bill_country = this.cvCountryOptions[findCountryIndex]
          }
        }

        if (this.vmOrganisationFormData.bill_country && this.vmOrganisationFormData.bill_country.country_code != "IN") {
          this.isStateDropdown = false
        }
        else {
          this.isStateDropdown = true
        }

        if (this.vmOrganisationFormData.bill_state_code < 10) {
          this.vmOrganisationFormData.bill_state_code = "0" + this.vmOrganisationFormData.bill_state_code
        }

        if (this.vmOrganisationFormData.org_domain) {
          this.readonlyFlag = true
        }
      }
      catch (err) {
        console.error("Exception in orgSaasView() and err: ", err)
      }
    },
    /**
     * openImageDialog
     *
     */
    openImageDialog (e, imageType) {
      this.updateImageType = imageType
      if (e.target.files.length > 0) {
        this.fileSrc = e.target.files[0]
      }

      let input = e.target
      if (input.files.length > 0 && input.files[0]) {
        let image = input.files[0]
        let allowedExtension = [ "image/png", "image/jpg", "image/jpeg", "image/webp" ]
        let maxSize = 4 * 1024 * 1024
        this.toastVariant = "danger"
        if (!allowedExtension.includes(image.type)) {
          if (imageType === "Profile Pic") {
            this.toastMsg = this.cvImageExtensionErrorMsg
            this.showToast = true
          }
          else {
            this.toastMsg = this.cvImageExtensionErrorMsg
            this.showToast = true
          }
          return false
        }
        else if (image.size > maxSize) {
          // validate image size
          if (imageType === "Profile Pic") {
            this.toastMsg = this.cvImageSizeErrorMsg
            this.showToast = true
          }
          else {
            this.toastMsg = this.cvImageSizeErrorMsg
            this.showToast = true
          }
          return false
        }

        this.toastVariant = ""
        if (imageType === "Profile Pic") {
          this.propStencilSize = {
            "width": 150,
            "height": 150
          }
          this.propCropDialogSize = "md"
        }
        else {
          this.propStencilSize = {
            "width": 970,
            "height": 240
          }
          this.propCropDialogSize = "xl"
        }
        this.propCropImageDialogOpen = Math.random()
      }
    },
    /**
     * initImageData
     */
    initImageData () {
      return {
        module_id: this.$route.params.org_id,
        module_name: this.orgType,
        image: [],
        image_type: {}
      }
    },

    /**
     * setStateFormField
     */
    setStateFormField () {
      if (this.vmOrganisationFormData.bill_country.country_code == "IN") {
        this.isStateDropdown = true
      }
      else {
        this.isStateDropdown = false
      }
    },
    /**
     * imageRemove
     */
    async imageRemove (imgType) {
      if (imgType === "profile_pic") {
        this.cvDelProfilePicLoading = true
      }
      else {
        this.cvDelCoverPicLoading = true
      }

      let img = imgType === "profile_pic" ? 2 : 3
      const imageUpdateResp = await Images.imageDelete(this, this.$route.params.org_id, img)
      await ApiResponse.responseMessageDisplay(this, imageUpdateResp)
      if (imageUpdateResp && !imageUpdateResp.resp_status) {
        return false
      }

      if (imgType === "profile_pic") {
        this.vmProfilePic = ""
        this.cvDelProfilePicLoading = false
      }
      else {
        this.vmCoverPic = ""
        this.cvDelCoverPicLoading = false
      }
    },
    /**
    * onChangeProfileImage
    */
    onChangeProfileImage (e, imageType) {
      try {
        const reader = new FileReader()
        reader.onload = async (e) => {
          if (imageType === "Profile Pic") {
            this.vmProfilePic = await reader.result
          }
          else {
            this.vmCoverPic = await reader.result
          }
        }
        // reader.readAsDataURL(image)
      }
      catch (err) {
        console.error("Exception occurred at onChangeProfilePic() and Exception:", err.message)
      }
    },
    /**
     * imageEdit
     */
    async imageEdit (imageType) {
      if (imageType === "Profile Pic" && this.vmOrganisationProPicImage.image.length === 0) {
        return false
      }

      if (imageType === "Cover Pic" && this.vmOrganisationCoverPicImage.image.length === 0) {
        return false
      }
      try {
        let image
        if (imageType === "Profile Pic") {
          this.cvProfilePicLoading = true
          image = this.vmOrganisationProPicImage
        }
        else {
          this.cvCoverPicLoading = true
          image = this.vmOrganisationCoverPicImage
        }
        const imageUpdateResp = await Images.imageProfileUpdate(this, image)

        await ApiResponse.responseMessageDisplay(this, imageUpdateResp)
        if (imageUpdateResp && !imageUpdateResp.resp_status) {
          return false
        }
        let imageResp = imageUpdateResp.resp_data
        if (imageResp && imageResp.length > 0) {
          if (imageType === "Profile Pic") {
            this.profilePicObj = imageResp[0]
          }
          else {
            this.coverPicObj = imageResp[0]
          }
          await this.addOrgToModules()
        }
        this.vmOrganisationProPicImage = Object.assign({}, this.initImageData())
      }
      catch (err) {
        console.error("Exception occurred at imagEdit() and Exception:", err.message)
      }
      finally {
        if (imageType === "Profile Pic") {
          this.cvProfilePicLoading = false
        }
        else {
          this.cvCoverPicLoading = false
        }
      }
    },
    /**
     * getCroppedImg
     */
    getCroppedImg (img) {
      if (this.updateImageType === "Profile Pic") {
        this.vmProfilePic = img
      }
      else {
        this.vmCoverPic = img
      }
    },
    /**
     * goToOrgSaasLoginPreview
     */
    goToOrgSaasLoginPreview () {
      if (this.vmOrganisationFormData.org_domain_is_validated == "HTTP_S_SSL_PROCESS_COMPLETE") {
        window.open(`https://${this.vmOrganisationFormData.org_domain}/login_preview/${this.cvOrgType}/${this.cvOrgId}`, "_blank")
      }
      else {
        window.open(`/login_preview/${this.cvOrgType}/${this.cvOrgId}`, "_blank")
      }
    },
    /**
     * emitCroppedImgFile
     */
    emitCroppedImgFile (imgObj) {
      let img = imgObj.imgFile
      let orgImg = imgObj.orgImage
      let imageType = this.updateImageType
      this.onChangeProfileImage(img, imageType)
      if (imageType === "Profile Pic") {
        this.vmOrganisationProPicImage = Object.assign({}, this.initImageData())
        this.vmOrganisationProPicImage.image.push(
          {
            "img": img,
            "name": orgImg.name
          }
        )
        this.vmOrganisationProPicImage.image_type[orgImg.name] = 2
      }
      else {
        this.vmOrganisationCoverPicImage = Object.assign({}, this.initImageData())
        this.vmOrganisationCoverPicImage.image.push(
          {
            "img": img,
            "name": orgImg.name
          }
        )
        this.vmOrganisationCoverPicImage.image_type[orgImg.name] = 3
      }
    },
    /**
     * openFile
     */
    openFile (url) {
      if (url === "") {
        // empty url means that univ admin has not accepted the application
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "This document can only be viewed after accepting the application"
        return
      }

      window.open(url, "_blank")
    },
    /**
     * onExtraCurricularAttatachmentChange
     */
    onExtraCurricularAttatachmentChange (event, extraCurricular, inputId) {
      const fileList = event.target.files

      if (fileList && fileList.length) {
        for (let file of fileList) {
          // Allowed file types
          let allowedExtensions = this.allowedExtensions.split(",")

          let maxSize = 5 * 1024 * 1024 // 5MB limit

          if (!allowedExtensions.includes(file.type)) {
            this.toastMsg = "Invalid file type. Please upload a supported file."
            this.toastVariant = "danger"
            this.showToast = true
            continue
          }

          if (file.size > maxSize) {
            this.toastMsg = "File size exceeds the 5MB limit."
            this.toastVariant = "danger"
            this.showToast = true
            continue
          }

          // Read file and store in extraCurricular
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = async (e) => {
            file.url = e.currentTarget.result
            file.fileName = file.name

            if (!extraCurricular.org_pancard_attach) {
              extraCurricular.org_pancard_attach = []
            }

            if (typeof extraCurricular.org_pancard_attach === "string") {
              extraCurricular.org_pancard_attach = JSON.parse(extraCurricular.org_pancard_attach)
            }

            extraCurricular.org_pancard_attach.unshift(file)

            // Reset input field
            const ele = document.getElementById(inputId)
            if (ele) {
              ele.value = ""
            }
          }
        }
      }
    },
    /**
     * goToSubsPlanList
     */
    goToSubsPlanList () {
      this.$router.push("/subscription_plans")
    },
    /**
     * goToOrgSaasDomainValidate
     * sets the domain validation status to NOT_VALIDATED and redirects to the certificate generation page
     */
    async goToOrgSaasDomainValidate () {
      try {
        const updateDomainValidationStatusResp = await Organisations.organisationEdit(this, { org_id: this.cvOrgId, org_domain_is_validated: "NOT_VALIDATED" })
        if (updateDomainValidationStatusResp.resp_status) {
          this.$router.push(`/org_domain_validate/${this.cvOrgType}/${this.cvOrgId}`)
        }
        else {
          ApiResponse.responseMessageDisplay(this, updateDomainValidationStatusResp)
        }
      }
      catch (err) {
        console.error("Exception in goToOrgSaasDomainValidate() and err: ", err.message)
      }
    }
  }
}
</script>
<style lang="scss">
  .attachmentCol {
    img {
      height: 32px;
      width: 32px;
      object-fit: contain;
      border: 2px solid aliceblue;
      margin-bottom: 6px;
    }
  }
  .extraCloseIcon {
    font-size: 18px;
    position: relative;
    top: -15px;
    cursor: pointer;
    z-index: 99;
    margin-left: -9px;
    color: #e5252c;
  }
  hr {
    border-bottom: 3px solid ;
  }
  .building_icon {
    font-size: 24px;
    margin-right: 15px;
    color: var(--iq-primary);
    top: 2px;
    position: relative;
  }
</style>
